import Router from "vue-router";
import { useLoginStore } from "src/stores/loginStore";

import DashboardLayout from "src/components/DashboardLayout.vue";
import Login from "src/pages/Login.vue";
import NotFound from "src/pages/NotFoundPage.vue";
import Unauthorized from "src/pages/Unauthorized.vue";
import Availity from "@/pages/Availity.vue";
import EMS from "@/pages/EMS.vue";
import Insync from "@/pages/Insync.vue";
import Directors from "@/pages/Directors.vue";
import InsuranceProviders from "@/pages/InsuranceProviders.vue";
import Users from "@/pages/Users.vue";

let pagesMenu = {
    path: "/pages",
    component: DashboardLayout,
    redirect: "/pages/availity",
    children: [
        {
            path: "availity",
            name: "Availity Page",
            component: Availity,
        },
        {
            path: "ems",
            name: "EMS Page",
            component: EMS,
        },
        {
            path: "insync",
            name: "Insync Page",
            component: Insync,
        },
        {
            path: "insurance-providers",
            name: "Insurance Providers Page",
            component: InsuranceProviders,
        },
        {
            path: "directors",
            name: "Directors Page",
            component: Directors,
        },
        {
            path: "users",
            name: "Users Page",
            component: Users,
        },
    ],
};


let loginPage = {
    path: "/login",
    name: "Login",
    component: Login,
};

let unauthorizedPage = {
    path: "/unauthorized",
    name: "Unauthorized",
    component: Unauthorized,
};

const routes = [
    {
        path: "/",
        redirect: "/login",
    },
    loginPage,
    pagesMenu,
    unauthorizedPage,
    {
        path: "*",
        component: NotFound,
    },
];

export const router = new Router({
    mode: "history",
    linkActiveClass: "active",
    base: "/",
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    const publicPages = ["/login"];
    const requiresAuth = !publicPages.includes(to.path);
    const store = useLoginStore();

    if (requiresAuth && !store.getLoggedIn) {
        return next("/login");
    }

    if (to.matched.some((r) => r.meta.requiresAdmin)) {
        if (store.isAdmin) {
            return next();
        }
        return next("/unauthorized");
    }

    next();
});

export default router;
